export const MEXICO_ID = 16

export function filterCountries(countries) {
  return countries.map(country => {

    // Remove USD currency from Mexico
    if (country.id === MEXICO_ID) {
      return {
        ...country,
        currencies: country.currencies.filter(currency => currency.code !== 'USD')
      };
    }
    return country;
  });
}